import {inject, InjectionToken} from "@angular/core";
import {Observable, fromEvent} from "rxjs";
import {DOCUMENT} from "@angular/common";
import {map} from "rxjs/operators";


export const KEYBOARD_KEY_PRESSED = new InjectionToken<Observable<string>>('Keyboard key pressed', {
  factory: () => {
    const documentRef = inject(DOCUMENT);
    return fromEvent(documentRef, 'keydown')
      .pipe(
        map((event: any) => event.key)
      )
  }
})


export const KEYBOARD_KEY_CODE_PRESSED = new InjectionToken<Observable<number>>('Keyboard key code pressed', {
  factory: () => {
    const documentRef = inject(DOCUMENT);
    return fromEvent(documentRef, 'keydown')
      .pipe(
        map((event: any) => event.keyCode)
      )
  }
})
